const API = `${process.env.REACT_APP_BACKEND_URL}/api/blog`;

export const BLOG_CATEGORIES = ["Marketing", "Finance", "HR", "Legale", "Organizzazione"];

export const fetchPosts = async (category) => {
  const url = category ? `${API}?category=${encodeURIComponent(category)}` : API;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Errore nel caricamento degli articoli");
  return res.json();
};

export const fetchPost = async (slug) => {
  const res = await fetch(`${API}/${encodeURIComponent(slug)}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error("Errore nel caricamento dell'articolo");
  return res.json();
};

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
